export default {"src":"/_next/static/media/lock.6fae0b76.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};